import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

const enum fields {
    desktopHeight = "desktopHeight",
    tabletHeight = "tabletHeight",
    mobileHeight = "mobileHeight",
}

interface Props extends WidgetProps {
    fields: {
        [fields.desktopHeight]: number;
        [fields.tabletHeight]: number;
        [fields.mobileHeight]: number;
    };
}

export interface SpacerStyles {
    wrapper?: InjectableCss;
}

export const spacerStyles: SpacerStyles = {
    wrapper: {
        css: css``,
    },
};

const Spacer: React.FC<Props> = props => {
    const heightStyles = {
        wrapper: {
            css: css`
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            padding-top: ${props.fields.mobileHeight}px;
                        `,
                        css`
                            padding-top: ${props.fields.mobileHeight}px;
                        `,
                        css`
                            padding-top: ${props.fields.tabletHeight}px;
                        `,
                        css`
                            padding-top: ${props.fields.desktopHeight}px;
                        `,
                        css`
                            padding-top: ${props.fields.desktopHeight}px;
                        `,
                    ]);
                }}
            `,
        },
    };

    const [styles] = useState(() => mergeToNew(spacerStyles, heightStyles));

    return <StyledWrapper {...styles.wrapper}></StyledWrapper>;
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: Spacer,
    definition: {
        group: "Basic",
        displayName: "Spacer",
        icon: "rectangle-wide",
        fieldDefinitions: [
            {
                name: fields.desktopHeight,
                displayName: "Desktop Height Pixels",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                tooltip: "",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.tabletHeight,
                displayName: "Tablet Height Pixels",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                tooltip: "",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.mobileHeight,
                displayName: "Mobile Height Pixels",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                tooltip: "",
                isRequired: true,
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
